function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { colors } from '../../../theme';
import { fonts } from '../../../theme';
import { createOwnUpStyle } from '../../style';
export var OwnUpInputAdornmentContainerStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  color: colors.PRIMARY,
  backgroundColor: colors.WHITE,
  fontSize: '15px',
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
  minWidth: '240px',
  height: '60px',
  padding: 0,
  margin: 0,
  border: 0,
  borderRadius: '3px',
  verticalAlign: 'top',
  marginTop: 15,
  marginBottom: 15,
  variants: {
    focused: {
      border: "1px solid ".concat(colors.PRIMARY),
      marginTop: 14,
      marginBottom: 14,
      marginLeft: -1,
      marginRight: -1
    },
    error: {
      border: "1px solid ".concat(colors.ERROR),
      marginTop: 14,
      marginBottom: 14,
      marginLeft: -1,
      marginRight: -1
    },
    bordered: {
      border: "1px solid ".concat(colors.GREY)
    },
    xsmall: {
      maxWidth: '200px'
    }
  }
}));
export var OwnUpInputAdornmentLabelStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  color: colors.PRIMARY_ALT,
  fontSize: '15px',
  lineHeight: '21px',
  display: 'block',
  position: 'absolute',
  marginTop: 18.5,
  marginLeft: 20,
  paddingTop: 0,
  transition: 'transform 0.3s',
  transitionTimingFunction: 'cubic-bezier(0.0, 0, 0.2, 1)',
  variants: {
    decorated: {
      marginLeft: 46
    },
    shrink: {
      transform: 'translate(0px, -7.5px) scale(0.73)',
      transformOrigin: 'top left'
    }
  }
}));
export var OwnUpInputAdornmentDecoratorStyle = createOwnUpStyle(_objectSpread(_objectSpread({}, fonts.GRAPHIK_REGULAR), {}, {
  fontSize: '15px',
  color: colors.PRIMARY,
  backgroundColor: colors.TRANSPARENT,
  position: 'absolute',
  lineHeight: '26px',
  marginTop: 17,
  marginLeft: 20,
  border: 'none'
}));